import React from "react";
import Selector from "../../../../../Components/Common/Selector";

const TutoringPurchaseForm = ({ onChange, handleSubmit, errors, formData }) => {
  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Selector
        name="packageStatus"
        label="Package Status"
        value={formData?.packageStatus}
        options={[
          { label: "Pending", value: "pending" },
          { label: "Contacted", value: "contacted" },
          { label: "Completed", value: "completed" },
        ]}
        isClearable={false}
        onChange={onChange}
        error={errors?.packageStatus}
        required
      />
    </form>
  );
};

export default TutoringPurchaseForm;
